<template>
    <div class="my-divider my-divider--horizontal" role="separator">
        <div class="my-divider__text display-flex">
            <slot />
        </div>
    </div>
</template>
